module.exports = __webpack_public_path__ + "img/41ne.e7d0a96e.svg";